import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import PrivateRoutes from "./PrivateRoutes";
import LogoutScreen from "../components/screens/LogoutScreen";
import AuthPage from "../modules/auth/AuthPage";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

export default function AppRoutes() {
  const {
    auth: { isLogedIn },
  } = useContext(AuthContext);
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="logout" element={<LogoutScreen />} />
        {isLogedIn ? (
          <>
            <Route path="/*" element={<PrivateRoutes />} />
            <Route index element={<Navigate to="/dashboard" />} />
          </>
        ) : (
          <>
            <Route path="auth/*" element={<AuthPage />} />
            <Route path="*" element={<Navigate to="/auth" />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}
